import createStore from "react-auth-kit/createStore";
import AuthProvider from "react-auth-kit/AuthProvider";
import createRefresh from "react-auth-kit/createRefresh";
import { refreshAuthToken } from "../../../services";

const refresh = createRefresh({
  interval: 10, // The time in sec to refresh the Access token,
  refreshApiCallback: async (param) => {
    try {
      const response = await refreshAuthToken(param);

      return {
        isSuccess: true,
        newAuthToken: response.access_token,
        newAuthTokenExpireIn: 900,
        newRefreshTokenExpiresIn: 604800,
      };
    } catch (error) {
      console.error(error);
      return {
        isSuccess: false,
      };
    }
  },
});

const store = createStore({
  authName: "__auth",
  authType: "cookie",
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === "https:",
  refresh,
  // debug: true,
});

const UserAuthProvider = ({ children }) => {
  return <AuthProvider store={store}>{children}</AuthProvider>;
};

export default UserAuthProvider;
